import { render, staticRenderFns } from "./FormComponentPrevCatodico.vue?vue&type=template&id=38e2dbf2"
import script from "./FormComponentPrevCatodico.vue?vue&type=script&lang=js"
export * from "./FormComponentPrevCatodico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports